import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  MenuItem,
  Menu,
  Typography,
  Pagination,
  PaginationItem,
  CircularProgress,
} from "@mui/material";
import {
  PrimaryTypography,
  StyledSecondaryServiceTypography,
  StyledOutlinedInput,
  SecondaryTypography,
  StyledTableCell,
  StyledTableRow,
  StyledSecondaryTypography,
} from "../../Theme";
import { ReactComponent as SearchIcon } from "../../Icons/Search.svg";
import { ReactComponent as SortIcon } from "../../Icons/Sort.svg";
import { ReactComponent as DeleteIcon } from "../../Icons/DeleteIcon.svg";
import { ReactComponent as ExclamatoryIcon } from "../../Icons/Exclamatory.svg";
import { ReactComponent as PreviousIcon } from "../../Icons/Previous.svg";
import { ReactComponent as NextIcon } from "../../Icons/Next.svg";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../AxiosInstance";
import AlertModal from "../../CommonComponents/AlertModal";
import { showToast } from "../../CommonComponents/Toaster";
import { useDialog } from "../../contexts/DialogContext";
import RelocateDialogComponent from "../../components/RelocateDialogComponent";
import ConfirmRelocateDialogComponent from "../../components/ConfirmRelocateDialogComponent";

const Company = () => {
  const navigate = useNavigate();
  const [sortAnchorEl, setSortAnchorEl] = useState(null);
  const [search, setSearch] = useState("");
  const [openRelocateDialog, setOpenRelocateDialog] = useState(false);
  const [openConfirmRelocateDialog, setOpenConfirmRelocateDialog] =
    useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  console.log(selectedCompany, "selectedCompany");
  const { showDialog, closeDialog } = useDialog();
  const sortOpen = Boolean(sortAnchorEl);
  const [paginationData, setPaginationData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState("10");
  const TableHeaders = ["Company", "No. of Project", "Action", " "];
  const [TableData, setTableData] = useState([]);
  console.log(TableData, "TableData");
  const [showAnchorEl, setshowAnchorEl] = useState(null);
  const [sortAsc, setSortAsc] = useState("");
  const showOpen = Boolean(showAnchorEl);
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deletingCompany, setDeletingComapany] = useState({
    id: null,
    name: "",
  });
  const [tableLoading, setTableDataLoading] = useState(false);
  const [relocateCompanyDetails, setRelocateCompanyDetils] = useState(null);
  const [relocateCompanyDetailsName, setRelocateCompanyDetilsName] =
    useState(null);
  const [relocateCompanyProjects, setRelocateCompanyProjects] = useState(null);

  let deleteModalDatas = {
    label: "Delete company",
    descriptionOne: "will be removed from company list.",
    isDeleteCompany: deletingCompany?.name,
    buttonOne: {
      variant: "outlined",
      color: "#0E5E84",
      backgroundColor: "#FFFFFF",
      text: "Cancel",
    },
    buttonTwo: {
      variant: "contained",
      color: "#FFFFFF",
      backgroundColor: "#B42318",
      text: "Confirm",
    },
  };

  useEffect(() => {
    getTableData();
  }, [search, sortAsc, rowsPerPage]);

  const closemodal = () => {
    setshowDeleteModal(false);
    setDeletingComapany({
      id: null,
      name: "",
    });
  };

  const getTableData = () => {
    setTableDataLoading(true);
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}company?sort=${sortAsc}&search=${search}&record_count=${rowsPerPage}`
      )
      .then((res) => {
        setTableData(res.data?.data?.companies);
        setPaginationData(res.data?.data?.pagination_details);
        setTableDataLoading(false);
      })
      .catch((err) => {
        if (err.response.status === 400) {
          setTableData([]);
        }
        setTableDataLoading(false);
      });
  };

  const handleDelete = async () => {
    setDeleteLoading(true);
    try {
      const response = await axiosInstance.delete(
        `${process.env.REACT_APP_API_URL}company/${deletingCompany?.id}`
      );
      if (response.status === 200) {
        showToast("Company deleted successfully");
        navigate("/company");
        setDeleteLoading(false);
        setshowDeleteModal(false);
        getTableData();
      }
      console.log(response.data);
    } catch (error) {
      console.log(error);
      showToast("Please try again later", "error");
      setDeleteLoading(false);
      setshowDeleteModal(false);
    } finally {
      setDeleteLoading(false);
      setshowDeleteModal(false);
    }
  };
  useEffect(() => {
    if (TableData.length === 0) {
      setCurrentPage(1);
    }
  }, [TableData]);

  const handleDeleteBasedOnPropertyCount = (e, value) => {
    e.stopPropagation();

    if (value?.properties_count > 0) {
      showDialog({
        title: "Unable to Delete",
        content: `There are currently ${value?.properties_count} active projects under ${value?.name}.Please transfer these projects to another company before proceeding with deletion.`,
        actions: (
          <Box display="flex" gap="20px">
            <Button
              onClick={() => {
                closeDialog();
                setRelocateCompanyDetils(null);
                setRelocateCompanyDetilsName(null);
                setRelocateCompanyProjects(null);
              }}
              variant="white"
            >
              Back
            </Button>
            <Button
              variant="Standard"
              onClick={() => {
                setRelocateCompanyDetils(value?.id);
                setRelocateCompanyDetilsName(value?.name);
                closeDialog();
                setOpenRelocateDialog(true);
                setRelocateCompanyProjects(value?.properties_count);
              }}
            >
              Relocate Projects
            </Button>
          </Box>
        ),
        icon: "failure",
      });
    } else {
      setDeletingComapany({
        id: value?.id,
        name: value?.name,
      });
      setshowDeleteModal(true);
    }
  };

  const handleRelocateClose = () => {
    setOpenRelocateDialog(false);
  };
  const handleConfirmRelocateClose = () => {
    setOpenConfirmRelocateDialog(false);
  };

  const handleRelocateSubmit = () => {
    setOpenRelocateDialog(false);
    setOpenConfirmRelocateDialog(true);
  };
  return (
    <>
      {showDeleteModal && (
        <AlertModal
          modalDatas={deleteModalDatas}
          confirmFunction={handleDelete}
          closeFunction={closemodal}
          loading={deleteLoading}
        />
      )}
      <RelocateDialogComponent
        open={openRelocateDialog}
        setSelectedCompany={setSelectedCompany}
        selectedCompany={selectedCompany}
        onClose={handleRelocateClose}
        onSubmit={handleRelocateSubmit}
        selectedCompanyId={relocateCompanyDetails}
        selectedCompanyName={relocateCompanyDetailsName}
      />
      <ConfirmRelocateDialogComponent
        open={openConfirmRelocateDialog}
        onClose={handleConfirmRelocateClose}
        selectedCompanyDetails={selectedCompany}
        relocatingCompanyId={relocateCompanyDetails}
        reloacatingCompanyName={relocateCompanyDetailsName}
        reloacatingCompanyProjects={relocateCompanyProjects}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <PrimaryTypography>Company</PrimaryTypography>
          <StyledSecondaryServiceTypography>
            Manage company information
          </StyledSecondaryServiceTypography>
        </Box>
        <Button
          sx={{
            borderRadius: "8px",
            padding: "10px 16px",
            backgroundColor: "#0E5E84",
            color: "#FFFFFF",
            fontWeight: 600,
            fontSize: "14px",
            "&:hover": {
              backgroundColor: "#0E4965",
            },
          }}
          onClick={() => navigate("/create-company")}
        >
          Add
        </Button>
      </Box>
      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #E5E7EB",
          padding: "20px 16px",
          marginTop: "30px",
          borderRadius: " 8px 8px 0px 0px",
          overflowX: "scroll",
          "::-webkit-scrollbar": { display: "none" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            height: "40px",
            minWidth: "580px",
          }}
        >
          <StyledOutlinedInput
            sx={{ flexGrow: 1 }}
            onChange={(e) => setSearch(e.target.value.toLowerCase())}
            placeholder="Search"
            startAdornment={<SearchIcon style={{ paddingRight: "5px" }} />}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #D2D6DB",
              borderRadius: "8px",
              padding: "10px 16px",
              boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
              ml: 2,
              "&:hover": { cursor: "pointer" },
            }}
            onClick={(e) => {
              setSortAnchorEl(e.currentTarget);
            }}
          >
            <SortIcon style={{ marginRight: "10px" }} />
            <SecondaryTypography style={{ fontSize: "14px" }}>
              Sort
            </SecondaryTypography>
          </Box>
        </Box>
      </Box>
      {tableLoading ? (
        <Box
          sx={{ width: "100%", height: "200px" }}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CircularProgress />
        </Box>
      ) : TableData.length > 0 ? (
        <>
          <TableContainer>
            <Table>
              <TableHead>
                <StyledTableRow sx={{ height: "44px" }}>
                  {TableHeaders.map((value, index) => (
                    <StyledTableCell
                      style={{ paddingRight: "15px", paddingLeft: "15px" }}
                      key={index}
                    >
                      {value}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {TableData.map((value, index) => (
                  <StyledTableRow
                    onClick={() => navigate(`/review-company/${value?.id}`)}
                    key={index}
                    sx={{ height: "70px" }}
                  >
                    <StyledTableCell>{value?.name}</StyledTableCell>
                    <StyledTableCell>{value?.properties_count}</StyledTableCell>
                    <StyledTableCell
                      onClick={() => navigate(`/review-company/${value?.id}`)}
                    >
                      View Details
                    </StyledTableCell>
                    <StyledTableCell>
                      <DeleteIcon
                        onClick={(e) => {
                          handleDeleteBasedOnPropertyCount(e, value);
                        }}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              backgroundColor: "#FFFFFF",
              borderTopStyle: "none !important",
              border: "1px solid #E5E7EB",
              borderRadius: "0px 0px 8px 8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 2.5,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography
                sx={{ color: "#4D5761", fontSize: "14px", fontWeight: 500 }}
              >
                Show :
              </Typography>
              <Box
                onClick={(e) => setshowAnchorEl(e.currentTarget)}
                sx={{
                  width: "95px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid #E5E7EB",
                  borderRadius: "6px",
                  ml: 2,
                  "&:hover": { cursor: "pointer" },
                }}
              >
                <Typography
                  sx={{ fontSize: "15px" }}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  {rowsPerPage} rows{" "}
                </Typography>
              </Box>
            </Box>
            <Pagination
              page={currentPage}
              count={paginationData?.last_page}
              size="medium"
              onChange={(e, value) => setCurrentPage(value)}
              shape="rounded"
              renderItem={(item) => (
                <PaginationItem
                  slots={{ previous: PreviousIcon, next: NextIcon }}
                  {...item}
                />
              )}
            />
          </Box>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "50vh",
            justifyContent: "center",
            borderRadius: "0px 0px 8px 8px",
            border: "1px solid #F9FAFB",
            backgroundColor: "#F9FAFB",
          }}
        >
          <>
            <ExclamatoryIcon />
            <Typography
              sx={{
                color: "#9DA4AE",
                fontSize: "16px",
                fontWeight: 600,
                my: 2,
              }}
            >
              No Company Here
            </Typography>
            <StyledSecondaryTypography
              sx={{
                color: "#9DA4AE",
                fontSize: "16px",
                fontWeight: 400,
              }}
            >
              There are no company to display at the moment.
            </StyledSecondaryTypography>
            <StyledSecondaryTypography
              sx={{
                color: "#9DA4AE",
                fontSize: "16px",
                fontWeight: 400,
              }}
            >
              You may add company by clicking the top right Add button.
            </StyledSecondaryTypography>
          </>
        </Box>
      )}
      <Menu
        sx={{ m: 0.5 }}
        open={showOpen}
        anchorEl={showAnchorEl}
        onClose={() => setshowAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem
          onClick={() => {
            setRowsPerPage(10);
            setshowAnchorEl(null);
          }}
        >
          <Typography>10 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(20);
            setshowAnchorEl(null);
          }}
        >
          <Typography>20 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(30);
            setshowAnchorEl(null);
          }}
        >
          <Typography>30 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(40);
            setshowAnchorEl(null);
          }}
        >
          <Typography>40 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(50);
            setshowAnchorEl(null);
          }}
        >
          <Typography>50 rows</Typography>
        </MenuItem>
      </Menu>

      <Menu
        sx={{ m: 0.5 }}
        open={sortOpen}
        anchorEl={sortAnchorEl}
        onClose={() => setSortAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            setSortAsc("old");
            setSortAnchorEl(null);
          }}
        >
          <styledTyphographyDefault>
            Alphabetical Asc. (A - Z)
          </styledTyphographyDefault>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setSortAsc("recent");
            setSortAnchorEl(null);
          }}
        >
          <styledTyphographyDefault>
            Alphabetical Dsc. (Z - A)
          </styledTyphographyDefault>
        </MenuItem>
      </Menu>
    </>
  );
};

export default Company;
